export default __webpack_public_path__ + "1f59e8e0170c830aeeb3d31d872881f5.webp";